import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useStores } from 'stores/index';

//@ts-ignore
import Background from '../../../assets/images/backgrounds/bg-deetail-account.png';

//@ts-ignore
import { Form, useForm, FormItem, InputText, notify, Button, Loading } from '@microui/react-ui';
//@ts-ignore
import { MicroIcon } from '@microui/react-icons';

const Main = () => {
  const [form] = useForm();
  const [editing, setEditing] = useState(false);
  const { userStore } = useStores();
  const [editData, setEditData] = useState({
    password: '******'
  });

  useEffect(() => {
    userStore.getProfile()
      .then(user => setEditData(state => ({ ...state, ...user })));
  }, []);

  const handleSubmit = (data) => {
    userStore.updateUser({
      country: data.country,
      email: data.email,
      locality: data.locality,
      name: data.name,
      phoneNumber: data.phoneNumber,
      postalCode: data.postalCode,
      profile: data.profile,
      region: data.region,
      streetAddress: data.streetAddress,
      website: data.website,
    })
      .then(user => {
        setEditData(state => ({ ...state, ...user }));
        notify.success('Cập nhật thành công');
      });
  };

  if (userStore.initing) {
    return <Loading size="large" loadingText="Đang lấy thông tin tài khoản..." />;
  }

  return (
    <div className="w-full h-[calc(100vh-60px)] flex flex-col overflow-y-auto pb-[50px]">
      <div
        className="max-h-[350px] min-h-[350px] pb-[74px] flex justify-center pt-[35px]"
        style={{
          backgroundImage: `url(${Background})`,
          backgroundSize: 'cover',
        }}
      >
        <div className="w-[1000px] min-h-[200px] flex">
          <div className="h-[200px] w-[80%] flex relative">
            <div className="w-[200px] h-[200px] rounded-full border-purple-100  border-[5px] overflow-hidden">
              {
                editing && (
                  <div className="absolute w-[50px] h-[50px] cursor-pointer rounded-full shadow-md left-[150px] bg-white flex justify-center items-center bottom-3">
                    <MicroIcon icon='add-photo' theme='outlined' />
                  </div>
                )
              }

              <img className='w-full h-full object-cover' src="https://st3.depositphotos.com/2585479/18264/v/600/depositphotos_182649394-stock-illustration-cute-dog-avatar.jpg" />
            </div>
            <div className="flex flex-col flex-1 justify-center pl-[26px]">
              <div className="text-headline-1 font-[600] text-white">
                {userStore.userData?.name}
              </div>
              <div className="text-headline-4 font-[600] text-white mt-[8px]">
                @{userStore.userData?.username}
              </div>
            </div>
          </div>
          <div
            className='flex-1 flex justify-end items-end mb-[38px]'
          >
            {
              !editing && (
                <div
                  onClick={() => setEditing(true)}
                  className="rounded-[18px] bg-white px-[16px] py-[8px] font-medium text-button-2 text-primary cursor-pointer"
                >
                  Chỉnh Sửa
                </div>
              )
            }

          </div>
        </div>
      </div>
      <div className="w-full -mt-[74px] flex justify-center">
        <div className="w-[1000px] bg-white rounded-8 shadow-md min-h-[200px] p-[50px]">
          <Form
            form={form}
            initialValues={editData}
            onChange={(values) => setEditData(values)}
            onFinish={handleSubmit}
          >
            <div className="grid grid-cols-1 gap-[50px]">
              <div className="flex">
                <div className='w-[40%]'>
                  <div className="text-headline-4 font-[600] text-gray-200">
                    Tài khoản
                  </div>
                  <div className='text-body-2 text-gray-400'>
                    Dùng để đăng nhập vào hệ thống MicroID
                  </div>
                </div>
                <div className='flex-1'>
                  <FormItem label="Username" name="username">
                    <InputText disabled />
                  </FormItem>
                  <FormItem label="Mật khẩu" name="password">
                    <InputText disabled />
                  </FormItem>
                </div>
              </div>
              <div className="flex">
                <div className='w-[40%]'>
                  <div className="text-headline-4 font-[600] text-gray-200">
                    Thông tin cá nhân
                  </div>
                  <div className='text-body-2 text-gray-400'>
                    Thông tin cá nhận của tài khoản
                  </div>
                </div>
                <div className='flex-1'>
                  <FormItem label="Họ tên" name="name" required>
                    <InputText disabled={!editing || userStore.loading} />
                  </FormItem>
                  <FormItem label="Email" name="email" required>
                    <InputText disabled={!editing || userStore.loading} />
                  </FormItem>
                  <FormItem label="Điện thoại" name="phoneNumber">
                    <InputText disabled={!editing || userStore.loading} />
                  </FormItem>
                  <FormItem label="Website URL" name="website">
                    <InputText disabled={!editing || userStore.loading} />
                  </FormItem>
                  <FormItem label="Profile URL" name="profile">
                    <InputText disabled={!editing || userStore.loading} />
                  </FormItem>
                  <FormItem label="Địa chỉ" name="streetAddress">
                    <InputText disabled={!editing || userStore.loading} />
                  </FormItem>
                  <FormItem label="Thành phố" name="locality">
                    <InputText disabled={!editing || userStore.loading} />
                  </FormItem>
                  <FormItem label="Tỉnh" name="region">
                    <InputText disabled={!editing || userStore.loading} />
                  </FormItem>
                  <FormItem label="Post code" name="postalCode">
                    <InputText disabled={!editing || userStore.loading} />
                  </FormItem>
                  <FormItem label="Quốc gia" name="country">
                    <InputText disabled={!editing || userStore.loading} />
                  </FormItem>
                </div>
              </div>
              {
                editing && (
                  <div className="flex">
                    <div className='w-[40%]'></div>
                    <div className='flex-1 flex'>
                      <Button disabled={userStore.loading} onClick={() => setEditing(false)}>Hủy</Button>
                      <Button loading={userStore.loading} className='ml-2' type='primary' onClick={form.submit} color='primary'>Lưu thay đổi</Button>
                    </div>
                  </div>
                )
              }
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default observer(Main);